import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
// import { openNotification } from "../../utils/funciones";
// import { ERROR } from "../../utils/uiText";

//------------- TYPES -------------------------

const LOADING_ASPIRANTE = "[ASPIRANTE] LOADING_ASPIRANTE";
const LOADING_ASPIRANTE_FORM = "[ASPIRANTE] LOADING_ASPIRANTE_FORM";

const SET_FORMULARIO = "[ASPIRANTE] SET_FORMULARIO";
const SET_FORMULARIO_CLEAN = "[ASPIRANTE] SET_FORMULARIO_CLEAN";
const CLEAN_STATE = "[ASPIRANTE] CLEAN_STATE";
const SET_IS_CONSULTA = "[ASPIRANTE] SET_IS_CONSULTA";
const OPEN_MODAL = "[ASPIRANTE] OPEN_MODAL";
const EXISTE_CORREO = "[ASPIRANTE] EXISTE_CORREO";
const VALIDA_RFC = "[ASPIRANTE] VALIDA_RFC";
const VALIDA_CURP = "[ASPIRANTE] VALIDA_CURP";
const VALIDA_CLAVE = "[ASPIRANTE] VALIDA_CLAVE";
const SET_ASPIRANTE = "[ASPIRANTE] SET_ASPIRANTE";
const SET_TAB_ASPIRANTE = "[ASPIRANTE] SET_TAB_ASPIRANTE";

//------------- STATE -------------------------
const initialState = {
  loading: false,
  tabAspirante: "1",
  modalLogin: false,
  loadingForm: false,
  consulta: {
    isConsulta: false,
    isModifica: false,
  },
  correo: {
    isValidCorreo: true,
    mensaje: null,
  },
  rfc: {
    isValidRfc: true,
    mensaje: null,
  },
  curp: {
    isValidCurp: true,
    mensaje: null,
  },
  clave: {
    isValidClave: true,
    mensaje: null,
  },
  formulario: {
    isSaved: false,
    isError: false,
    mensaje: null,
  },
  aspiranteById: {},
};

//------------- REDUCER -------------------------
const aspiranteReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ASPIRANTE:
      return {
        ...state,
        loading: action.payload,
      };
    case LOADING_ASPIRANTE_FORM:
      return {
        ...state,
        loadingForm: action.payload,
      };

    case SET_FORMULARIO:
      return {
        ...state,
        formulario: {
          isSaved: action.payload.isSaved,
          isError: action.payload.isError,
          mensaje: action.payload.message,
        },
      };
    case SET_FORMULARIO_CLEAN:
      return {
        ...state,
        formulario: {
          isSaved: false,
          isError: false,
          mensaje: null,
        },
      };

    case SET_IS_CONSULTA:
      return {
        ...state,
        consulta: {
          ...action.payload,
        },
      };
    case SET_ASPIRANTE:
      return {
        ...state,
        aspiranteById: {
          // ...state.aspirante,
          ...action.payload,
        },
      };

    case EXISTE_CORREO:
      return {
        ...state,
        correo: {
          isValidCorreo: action.payload.isValidCorreo,
          mensaje: action.payload.mensaje,
        },
      };
    case VALIDA_RFC:
      return {
        ...state,
        rfc: {
          ...action.payload,
        },
      };
    case VALIDA_CURP:
      return {
        ...state,
        curp: {
          ...action.payload,
        },
      };
    case VALIDA_CLAVE:
      return {
        ...state,
        clave: {
          ...action.payload,
        },
      };
    case OPEN_MODAL:
      return {
        ...state,
        modalLogin: !state.modalLogin,
      };
    case SET_TAB_ASPIRANTE:
      return {
        ...state,
        tabAspirante: action.payload,
      };

    case CLEAN_STATE:
      return initialState;

    default:
      return state;
  }
};

export default aspiranteReducer;

//------------- ACTIONS -------------------------

/**
 * Action para activar el loading
 * @param {boolean} status
 */
export const setLoading = (status) => ({
  type: LOADING_ASPIRANTE,
  payload: status,
});

export const setLoadingForm = (status) => ({
  type: LOADING_ASPIRANTE_FORM,
  payload: status,
});

export const openModalLogin = () => ({
  type: OPEN_MODAL,
});

/**
 * Action para limpiar el state
 */
export const cleanAspirante = () => ({
  type: CLEAN_STATE,
});

/**
 * Action para almacenar la respuesta del formulario.
 * @param {boolean} isError: Si hubo un error al momento de registrar/actualizar un aspirante
 * @param {boolean} isSaved: Si se registro/actualizó correctamente un aspirante
 * @param {string} message : Mensaje recibido
 */
export const setFormulario = (isError, isSaved, message) => ({
  type: SET_FORMULARIO,
  payload: {
    isError,
    message,
    isSaved,
  },
});

export const setCorreo = (isValidCorreo, mensaje) => ({
  type: EXISTE_CORREO,
  payload: {
    isValidCorreo,
    mensaje,
  },
});

export const setValidaRfc = (state) => ({
  type: VALIDA_RFC,
  payload: state,
});

export const setValidaCurp = (state) => ({
  type: VALIDA_CURP,
  payload: state,
});

export const setValidaClave = (state) => ({
  type: VALIDA_CLAVE,
  payload: state,
});

export const setTabAspirante = (state) => ({
  type: SET_TAB_ASPIRANTE,
  payload: state,
});

/**
 * Función que limpia el state de los mensajes recibidos del back
 */
export const setFormularioClean = () => ({
  type: SET_FORMULARIO_CLEAN,
});

//--------------------------------- Edición -----------------------------------------------
export const setIsConsulta = (isConsulta, isModifica) => ({
  type: SET_IS_CONSULTA,
  payload: {
    isConsulta,
    isModifica,
  },
});
/**
 * Función que gurarda los datos del aspirante que han sido consultados por ID
 * @param {object} state : Aspirante
 */
export const setAspirante = (state) => ({
  type: SET_ASPIRANTE,
  payload: state,
});

/**
 *Función para guardar los datos del aspirante
 * @param {object} form : Formulario del registro de aspirante
 */
export const saveAspirante = (formData) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  const { data } = await axios(window.location.origin + JSON_URL);
  await axios
    .post(`${data.urlServer}${data.urlRegistroAspirante}`, formData, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    })
    .then((resp) => {
      const { data } = resp;
      if (data.idMensaje === 1) {
        dispatch(setFormulario(false, true, data.mensaje));
      } else {
        dispatch(setFormulario(true, false, data.mensaje));
      }
    })
    .catch((error) => {
      console.log(error);
      const { data } = error.response;
      dispatch(setFormulario(true, false, data.mensaje));
    });
  dispatch(setLoading(false));
};

/**
 *Función para actualizar los datos del aspirante
 * @param {object} form : Formulario de aspirante
 */
export const updateAspirante = (form) => async (dispatch, getState) => {
  dispatch(setLoadingForm(true));
  //Get token
  const { accessToken } = getState().usuarioLogin;
  const { data } = await axios(window.location.origin + JSON_URL);

  await axios
    .post(`${data.urlServer}${data.urlActualizaAspirante}`, form, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    .then((resp) => {
      const { data } = resp;
      if (data.idMensaje === 1) {
        dispatch(setFormulario(false, true, data.mensaje));
        dispatch(getAspiranteById());
      } else {
        dispatch(setFormulario(true, false, data.mensaje));
      }
    })
    .catch((error) => {
      const { data } = error.response;
      dispatch(setFormulario(true, false, data.mensaje));
    });
  dispatch(setLoadingForm(false));
};

/**
 * Función que obtiene los datos de un Aspirante por ID
 * @returns Aspirante
 */
export const getAspiranteById = () => async (dispatch, getState) => {
  dispatch(setLoading(true));
  const { data } = await axios(window.location.origin + JSON_URL);
  const { idAspirante, accessToken } = getState().usuarioLogin;
  await axios
    .post(
      `${data.urlServer}${data.urlAspiranteById}`,
      { idAspirante },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    )
    .then((resp) => {
      const { data } = resp;
      dispatch(setAspirante(data));
    })
    .catch((error) => {
      const { data } = error.response;
      console.error(data)
      // openNotification("error", ERROR, data.mensaje);
    });
  dispatch(setLoading(false));
};

/**
 * Función que valida si existe el correo solicitado
 * @param {string} email
 * @returns Si existe el correo capturado
 */
export const existeCorreo = (email) => async (dispatch, getState) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    await axios
      .post(`${urls.data.urlServer}${urls.data.urlValidaCorreo}`, {
        email,
      })
      .then((resp) => {
        // console.log(resp.data)
        dispatch(setCorreo(true, null));
      })
      .catch(({ response }) => {
        dispatch(setCorreo(false, response.data.mensaje));
      });
  } catch (error) {
    console.log("Error al validar el correo");
  }
};

/**
 * Función para validar los campos de RFC, CURP y Clave de elector
 * @param {number} idValor 1.- RFC, 2.- CURP y 3.-Clave de elector
 * @param {string} valor: texto a validar
 */
export const getValidaDatos = (idValor, valor) => async (dispatch) => {
  try {
    const urls = await axios(window.location.origin + JSON_URL);

    await axios
      .post(`${urls.data.urlServer}${urls.data.urlValidaDatos}`, {
        idValor,
        valor,
      })
      .then((resp) => {
        const { idMensaje, mensaje } = resp.data;
        switch (idValor) {
          case 1: //Valida el RFC
            const isValidRfc = idMensaje === 1;
            dispatch(setValidaRfc({ isValidRfc, mensaje }));
            break;
          case 2: //Valida el curp
            const isValidCurp = idMensaje === 1;
            dispatch(setValidaCurp({ isValidCurp, mensaje }));
            break;
          case 3: //Valida la Clave de elector
            const isValidClave = idMensaje === 1;
            dispatch(setValidaClave({ isValidClave, mensaje }));
            break;
          default:
            break;
        }
      })
      .catch(({ response }) => {
        console.log("Error en la validación");
      });
  } catch (error) {
    console.log("Error en la validación");
  }
};
